import { APP_BASE_PATH } from '../config';

export default class UrlHelper {
    public static getFullPath(path: string): string {
        // add a slash at the start if needed
        return APP_BASE_PATH + (path.startsWith('/') ? path : '/' + path);
    }

    public static stripBasePath(path: string): string {
        if (!this.includesBasePath(path)) return path;
        // return everything after the base path
        return path.substring(APP_BASE_PATH.length);
    }

    public static includesBasePath(path: string): boolean {
        return path.includes(APP_BASE_PATH);
    }

    public static replacePath(path: string): void {
        window.location.replace(UrlHelper.getFullPath(path));
    }

    public static buildUrl(path: string, search: string | URLSearchParams): string {
        return `${path}${search.toString().startsWith('?') ? '' : '?'}${search}`;
    }
}
